import React from "react";
import { useNavigate } from "react-router-dom";
import { EventButton, DeadlineDisplay } from "../common";
import { NEWYEAR_ROUTES } from "../../../constants/newyearConstants";
import { formatWinnerRank } from "../../../utils/newyear/formatters";

const ResultWin = ({ result, eventId }) => {
  const navigate = useNavigate();

  const handleGoToWinnerInfo = () => {
    navigate(`${NEWYEAR_ROUTES.WINNER_INFO}/${eventId}`);
  };

  if (!result) return null;

  return (
    <div className="newyear-result newyear-result--win">
      <div className="newyear-result__icon">
        <span className="newyear-result__emoji">
          &#127881;
        </span>
      </div>

      <h2 className="newyear-result__title">축하합니다!</h2>
      <p className="newyear-result__message">
        퀴즈 정답을 맞추셨습니다!
      </p>

      {result.rank && (
        <p className="newyear-result__rank">
          {formatWinnerRank(result.rank)}
        </p>
      )}

      {result.infoSubmissionDeadline && (
        <DeadlineDisplay
          deadline={result.infoSubmissionDeadline}
          label="당첨자 정보 제출 마감"
        />
      )}

      <div className="newyear-result__notice">
        <p>경품 수령을 위해 당첨자 정보를 입력해주세요.</p>
        <p className="newyear-result__warning">
          기한 내 미입력 시 당첨이 취소됩니다.
        </p>
      </div>

      <div className="newyear-result__actions">
        <EventButton
          variant="success"
          size="large"
          fullWidth
          onClick={handleGoToWinnerInfo}
        >
          당첨자 정보 입력하기
        </EventButton>
      </div>
    </div>
  );
};

export default ResultWin;
